module.exports = __webpack_public_path__ + "media/images/pagetitles/gigs-a688daebf58ff06bce07ce26b6052d95.gif";